module.exports = __webpack_public_path__ + "img/bg_plan_type_family.e444d785.jpg";